// src/pages/Residential/Optional/SuicideDetail/SuicideDetailForm.js
import React from "react";

const SuicideDetailForm = ({ formData, handleChange }) => {
    const frequencyOptions = [
        { value: "All of the time", label: "All of the time" },
        { value: "Most of the time", label: "Most of the time" },
        { value: "Some of the time", label: "Some of the time" },
        { value: "A little of the time", label: "A little of the time" },
        { value: "None of the time", label: "None of the time" }
    ];

    const intensityOptions = [
        { value: "Very intense", label: "Very intense" },
        { value: "Intense", label: "Intense" },
        { value: "Somewhat intense", label: "Somewhat intense" },
        { value: "Not at all intense", label: "Not at all intense" }
    ];

    const likelihoodOptions = [
        { value: "Very likely", label: "Very likely" },
        { value: "Likely", label: "Likely" },
        { value: "Unlikely", label: "Unlikely" },
        { value: "Very unlikely", label: "Very unlikely" }
    ];

    const contactFrequencyOptions = [
        { value: "Daily", label: "Daily" },
        { value: "A few days a week", label: "A few days a week" },
        { value: "Weekly", label: "Weekly" },
        { value: "Monthly", label: "Monthly" },
        { value: "Less than once a month", label: "Less than once a month" }
    ];

    const upsettingEvents = [
        "Family breakdown",
        "Relationship problem",
        "Loss of loved one",
        "Conflict relating to sexual identity",
        "Impending legal prosecution",
        "Child custody issues",
        "Chronic pain/illness",
        "Trauma"
    ];

    const presentationItems = [
        "Agitated",
        "Disorientated/confused",
        "Delusional/hallucinating",
        "Intoxicated",
        "Self-harm"
    ];

    const riskLevels = [
        { value: "Low", label: "Low" },
        { value: "Moderate", label: "Moderate" },
        { value: "High", label: "High" }
    ];

    // Helper for checkbox arrays
    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;
        if (name === "q6_events" || name === "presentation") {
            handleChange({
                target: {
                    name,
                    value: checked
                        ? [...(formData[name] || []), value]
                        : (formData[name] || []).filter((v) => v !== value)
                }
            });
        } else {
            handleChange(e);
        }
    };

    return (
        <>
            <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                {/* Header */}
                <div className="row g-3 mb-5">
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="clientName" value={formData.clientName || ""} onChange={handleChange} readOnly={!!formData.patientId} />
                            <label>Client</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="completedBy" value={formData.completedBy || ""} onChange={handleChange} />
                            <label>Screen completed by</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="date" className="form-control" name="date" value={formData.date || ""} onChange={handleChange} />
                            <label>Date</label>
                        </div>
                    </div>
                </div>

                <div className="accordion" id="suicideAccordion">

                    {/* Questions 1-4 */}
                    {[1, 2, 3, 4].map((qNum) => {
                        const questions = [
                            "In the past 4 weeks did you feel so sad that nothing could cheer you up?",
                            "In the past 4 weeks, how often did you feel no hope for the future?",
                            "In the past 4 weeks, how often did you feel intense shame or guilt?",
                            "In the past 4 weeks, how often did you feel worthless?"
                        ];
                        return (
                            <div className="accordion-item mb-3 shadow-sm rounded" key={qNum}>
                                <h2 className="accordion-header">
                                    <button className={`accordion-button fw-semibold ${qNum !== 1 ? "collapsed" : ""}`} type="button" data-bs-toggle="collapse" data-bs-target={`#q${qNum}`}>
                                        {qNum}. {questions[qNum - 1]}
                                    </button>
                                </h2>
                                <div id={`q${qNum}`} className={`accordion-collapse collapse ${qNum === 1 ? "show" : ""}`}>
                                    <div className="accordion-body pt-4">
                                        <div className="row g-4 justify-content-center">
                                            {frequencyOptions.map((opt) => (
                                                <div className="col-lg-2 col-md-4" key={opt.value}>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name={`q${qNum}`}
                                                            id={`q${qNum}_${opt.value}`}
                                                            value={opt.value}
                                                            checked={formData[`q${qNum}`] === opt.value}
                                                            onChange={handleChange}
                                                        />
                                                        <label className="form-check-label cursor-pointer" htmlFor={`q${qNum}_${opt.value}`}>
                                                            {opt.label}
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                    {/* Question 5: Previous Attempts */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q5">
                                5. Have you ever tried to kill yourself?
                            </button>
                        </h2>
                        <div id="q5" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4  text-center mb-4">
                                    Previous Suicide Attempts
                                </small>

                                <div className="d-flex justify-content-center gap-5 mb-5">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q5" id="q5_yes" value="yes" checked={formData.q5 === "yes"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q5_yes">Yes</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q5" id="q5_no" value="no" checked={formData.q5 === "no"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q5_no">No</label>
                                    </div>
                                </div>

                                {formData.q5 === "yes" && (
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-3 px-3 ">
                                                a. How many times have you tried to kill yourself?
                                            </small>
                                            <div className="d-flex flex-wrap gap-4">
                                                {["Once", "Twice", "3 +"].map((opt) => (
                                                    <div className="form-check" key={opt}>
                                                        <input className="form-check-input" type="radio" name="q5_attempts" id={`attempts_${opt.replace(/\s+/g, "")}`} value={opt} checked={formData.q5_attempts === opt} onChange={handleChange} />
                                                        <label className="form-check-label cursor-pointer" htmlFor={`attempts_${opt.replace(/\s+/g, "")}`}>{opt}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-3 px-3 ">
                                                b. How long ago was the last attempt?
                                            </small>
                                            <div className="row g-3">
                                                {["In the last 2 months", "2-6 months ago", "6-12 months ago", "1-2 years ago", "More than 2 years ago"].map((opt) => (
                                                    <div className="col-6" key={opt}>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="q5_lastAttempt" id={`attempts_${opt.replace(/\s+/g, "")}`} value={opt} checked={formData.q5_lastAttempt === opt} onChange={handleChange} />
                                                            <label className="form-check-label cursor-pointer" htmlFor={`attempts_${opt.replace(/\s+/g, "")}`}>{opt}</label>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="mt-4">
                                                <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                    Have things changed since?
                                                </small>
                                                <div className="form-floating form-floating-outline">
                                                    <input type="text" className="form-control" name="q5_changes" value={formData.q5_changes || ""} onChange={handleChange} />
                                                    <label>Details of changes</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Question 6: Upsetting Events */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q6">
                                6. Have you gone through any upsetting events recently? (tick all that apply)
                            </button>
                        </h2>
                        <div id="q6" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4  text-center mb-4">
                                    Recent Upsetting Events
                                </small>

                                <div className="d-flex justify-content-center gap-5 mb-5">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q6" id="q6_yes" value="yes" checked={formData.q6 === "yes"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q6_yes">Yes</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q6" id="q6_no" value="no" checked={formData.q6 === "no"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q6_no">No</label>
                                    </div>
                                </div>

                                {formData.q6 === "yes" && (
                                    <>
                                        <div className="row g-3 mb-4">
                                            {upsettingEvents.map((event) => (
                                                <div className="col-lg-3 col-md-6" key={event}>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" id={`attempts_${event.replace(/\s+/g, "")}`} name="q6_events" value={event} checked={formData.q6_events?.includes(event) || false} onChange={handleCheckboxChange} />
                                                        <label className="form-check-label cursor-pointer" htmlFor={`attempts_${event.replace(/\s+/g, "")}`}>{event}</label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="row g-3">
                                            <div className="col-md-12">
                                                <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                    Other (specify)
                                                </small>
                                                <div className="form-floating form-floating-outline">
                                                    <input type="text" className="form-control" name="q6_other" value={formData.q6_other || ""} onChange={handleChange} />
                                                    <label>Specify other event</label>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Question 7: Current Suicidal Thoughts */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q7">
                                7. Have things been so bad lately that you have thought about killing yourself?
                            </button>
                        </h2>
                        <div id="q7" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4  text-center mb-4">
                                    Current Suicidal Thoughts
                                </small>

                                <div className="d-flex justify-content-center gap-5 mb-5">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q7" id="q7_yes" value="yes" checked={formData.q7 === "yes"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q7_yes">Yes</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q7" id="q7_no" value="no" checked={formData.q7 === "no"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q7_no">No</label>
                                    </div>
                                </div>

                                {formData.q7 === "yes" && (
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                a. How often do you have thoughts of suicide?
                                            </small>
                                            <div className="form-floating form-floating-outline">
                                                <input type="text" className="form-control" name="q7_frequency" value={formData.q7_frequency || ""} onChange={handleChange} />
                                                <label>Frequency of thoughts</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                b. How long have you been having these thoughts?
                                            </small>
                                            <div className="form-floating form-floating-outline">
                                                <input type="text" className="form-control" name="q7_duration" value={formData.q7_duration || ""} onChange={handleChange} />
                                                <label>Duration</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                c. How intense are these thoughts when they are most severe?
                                            </small>
                                            <div className="d-flex gap-4 mt-2">
                                                {intensityOptions.map((opt) => (
                                                    <div className="form-check" key={opt.value}>
                                                        <input className="form-check-input" type="radio" name="q7_intensitySevere" value={opt.value} checked={formData.q7_intensitySevere === opt.value} onChange={handleChange} />
                                                        <label className="form-check-label cursor-pointer">{opt.label}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                d. How intense have these thoughts been in the last week?
                                            </small>
                                            <div className="d-flex gap-4 mt-2">
                                                {intensityOptions.map((opt) => (
                                                    <div className="form-check" key={opt.value}>
                                                        <input className="form-check-input" type="radio" name="q7_intensityWeek" value={opt.value} checked={formData.q7_intensityWeek === opt.value} onChange={handleChange} />
                                                        <label className="form-check-label cursor-pointer">{opt.label}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Question 8: Current Plan - Enhanced UI */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q8">
                                8. Do you have a current plan for how you would attempt suicide?
                            </button>
                        </h2>
                        <div id="q8" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4  text-center mb-4">
                                    Current Suicide Plan
                                </small>

                                <div className="d-flex justify-content-center gap-5 mb-5">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q8" id="q8_yes" value="yes" checked={formData.q8 === "yes"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q8_yes">Yes</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q8" id="q8_no" value="no" checked={formData.q8 === "no"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q8_no">No</label>
                                    </div>
                                </div>

                                {formData.q8 === "yes" && (
                                    <div className="row g-4">
                                        {/* Row 1: a, b, c */}
                                        <div className="col-md-4">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                a. What method would you use?
                                            </small>
                                            <div className="form-floating form-floating-outline mb-3">
                                                <input type="text" className="form-control" name="q8_method" value={formData.q8_method || ""} onChange={handleChange} />
                                                <label>Method</label>
                                            </div>

                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                Access to means?
                                            </small>
                                            <div className="d-flex gap-4">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="q8_access" value="yes" checked={formData.q8_access === "yes"} onChange={handleChange} />
                                                    <label className="form-check-label cursor-pointer">Yes</label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="q8_access" value="no" checked={formData.q8_access === "no"} onChange={handleChange} />
                                                    <label className="form-check-label cursor-pointer">No</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                b. Where would this occur?
                                            </small>
                                            <div className="form-floating form-floating-outline mb-3">
                                                <input type="text" className="form-control" name="q8_location" value={formData.q8_location || ""} onChange={handleChange} />
                                                <label>Location</label>
                                            </div>

                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                Have all necessary preparations been made?
                                            </small>
                                            <div className="d-flex gap-4">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="q8_preparations" value="yes" checked={formData.q8_preparations === "yes"} onChange={handleChange} />
                                                    <label className="form-check-label cursor-pointer">Yes</label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="q8_preparations" value="no" checked={formData.q8_preparations === "no"} onChange={handleChange} />
                                                    <label className="form-check-label cursor-pointer">No</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                                c. How likely are you to act on this plan in the near future?
                                            </small>
                                            <div className="d-flex flex-column gap-3 mt-2">
                                                {likelihoodOptions.map((opt) => (
                                                    <div className="form-check" key={opt.value}>
                                                        <input className="form-check-input" type="radio" name="q8_likelihood" value={opt.value} checked={formData.q8_likelihood === opt.value} onChange={handleChange} />
                                                        <label className="form-check-label cursor-pointer">{opt.label}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Question 9: What has stopped you */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q9">
                                9. What has stopped you acting on these suicidal thoughts?
                            </button>
                        </h2>
                        <div id="q9" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4  text-center mb-4">
                                    Barriers to Acting on Suicidal Thoughts
                                </small>
                                <div className="form-floating form-floating-outline">
                                    <textarea className="form-control" name="q9_stopped" value={formData.q9_stopped || ""} onChange={handleChange} rows="5" style={{ height: "140px" }} />
                                    <label>Reasons preventing action</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Question 10: Support Network */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q10">
                                10. Do you have any friends/family members you can confide in if you have a serious problem?
                            </button>
                        </h2>
                        <div id="q10" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4  text-center mb-4">
                                    Support Network
                                </small>

                                <div className="d-flex justify-content-center gap-5 mb-5">
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q10" id="q10_yes" value="yes" checked={formData.q10 === "yes"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q10_yes">Yes</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" name="q10" id="q10_no" value="no" checked={formData.q10 === "no"} onChange={handleChange} />
                                        <label className="form-check-label cursor-pointer fw-medium" htmlFor="q10_no">No</label>
                                    </div>
                                </div>

                                {formData.q10 === "yes" && (
                                    <>
                                        <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                            a. Who is/are this/these person/people?
                                        </small>
                                        <div className="form-floating form-floating-outline mb-4">
                                            <textarea className="form-control" name="q10_people" value={formData.q10_people || ""} onChange={handleChange} rows="4" style={{ height: "120px" }} />
                                            <label>Names of supportive people</label>
                                        </div>

                                        <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-2 px-3 ">
                                            b. How often are you in contact with this/these person/people?
                                        </small>
                                        <div className="d-flex gap-4 justify-content-center">
                                            {contactFrequencyOptions.map((opt) => (
                                                <div className="form-check" key={opt.value}>
                                                    <input className="form-check-input" type="radio" name="q10_contact" value={opt.value} checked={formData.q10_contact === opt.value} onChange={handleChange} />
                                                    <label className="form-check-label cursor-pointer">{opt.label}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Question 11: Past Coping */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q11">
                                11. What has helped you through difficult times in the past?
                            </button>
                        </h2>
                        <div id="q11" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4  text-center mb-4">
                                    Past Coping Strategies
                                </small>
                                <div className="form-floating form-floating-outline">
                                    <textarea className="form-control" name="q11_pastHelp" value={formData.q11_pastHelp || ""} onChange={handleChange} rows="5" style={{ height: "140px" }} />
                                    <label>What has helped in the past</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Client Presentation - "Other" integrated into list */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#presentation">
                                Client Presentation / Statements
                            </button>
                        </h2>
                        <div id="presentation" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-danger fw-bold d-block mb-4 px-4  bg-light rounded">
                                    NOTE: If client presents as any of the below and is expressing thoughts of suicide, risk level is automatically HIGH
                                </small>

                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-4  text-center">
                                    Current Presentation (tick all that apply)
                                </small>

                                <div className="row g-3">
                                    {[...presentationItems, "Other"].map((item) => (
                                        <div className="col-lg-4 col-md-6" key={item}>
                                            {item === "Other" ? (
                                                <div className="d-flex align-items-start gap-3">
                                                    <div className="form-check mt-1">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            name="presentation"
                                                            value="Other"
                                                            checked={formData.presentation?.includes("Other") || false}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label cursor-pointer">Other (specify)</label>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="presentation_other"
                                                            value={formData.presentation_other || ""}
                                                            onChange={handleChange}
                                                            disabled={!formData.presentation?.includes("Other")}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        name="presentation"
                                                        value={item}
                                                        checked={formData.presentation?.includes(item) || false}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label className="form-check-label cursor-pointer">{item}</label>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Worker Rated Risk Level */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#riskLevel">
                                Worker Rated Risk Level
                            </button>
                        </h2>
                        <div id="riskLevel" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block px-4  text-center mb-4">
                                    Overall Risk Assessment by Worker
                                </small>

                                <div className="d-flex justify-content-center gap-5">
                                    {riskLevels.map((opt) => (
                                        <div className="form-check" key={opt.value}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="workerRiskLevel"
                                                value={opt.value}
                                                checked={formData.workerRiskLevel === opt.value}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label cursor-pointer fw-bold fs-5">{opt.label}</label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SuicideDetailForm;